import React from 'react';
import { motion } from 'framer-motion';
import { Search, PenTool, Code2, Rocket, TrendingUp } from 'lucide-react';
import './Process.css';

const steps = [
    {
        number: "01",
        title: "Discover",
        description: "We understand your business, goals, and challenges.",
        icon: <Search size={22} />
    },
    {
        number: "02",
        title: "Design",
        description: "We turn ideas into clear digital experiences and solutions.",
        icon: <PenTool size={22} />
    },
    {
        number: "03",
        title: "Build",
        description: "Our engineers develop your solution using modern technology.",
        icon: <Code2 size={22} />
    },
    {
        number: "04",
        title: "Deploy",
        description: "We launch your solution and make it ready for real-world use.",
        icon: <Rocket size={22} />
    },
    {
        number: "05",
        title: "Grow",
        description: "We continue improving and supporting your digital ecosystem.",
        icon: <TrendingUp size={22} />
    }
];

const containerVariants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.15 } }
};

const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } }
};

const Process = () => {
    return (
        <section id="process" className="process-section-light">
            <div className="container">
                <motion.div
                    className="section-header"
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                >
                    <span className="section-badge">How We Work</span>
                    <h2 className="section-title text-dark">From Idea to <span className="text-gradient">Impact</span></h2>
                    <p className="section-description">
                        A proven engineering process to turn your vision into a scalable digital solution.
                    </p>
                </motion.div>

                <motion.div
                    className="process-grid-new"
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: '-80px' }}
                >
                    {steps.map((step, index) => (
                        <motion.div
                            key={index}
                            className="process-card-new"
                            variants={cardVariants}
                        >
                            <div className="process-step-num-new">{step.number}</div>
                            <h3 className="process-step-title-new">{step.title}</h3>
                            <p className="process-step-desc-new">{step.description}</p>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default Process;
